import { Contact, Patient } from 'solid-workflow-service-typescript-axios';

function toDisplayName(contact?: Contact | Patient): string {
  return [contact?.firstName, contact?.lastName].join(' ');
}

export default toDisplayName;
